// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#242836","menuActiveText":"#435ebe","theme":"#ffba00"};